<template>
  <v-container fluid class="pl-15 pr-10">
    <AuthCtrl :parm_step="7"></AuthCtrl>
    <div class="d-flex justify-center mt-5">
        <v-stepper flat class="d-flex" style="background: transparent">
          <v-stepper-step step="1" complete class="flex-column pr-0" color="#2CD8C5">
            <v-btn flat
              class="mt-5 text-capitalize font-weight-bold titleText--text"
                small depressed
                @click="onnextclick(), goTo('sessionalitysetting')">Seasonality & Decay</v-btn>
          </v-stepper-step>
          <div class="border__dashed">
          </div>
          <v-stepper-step step="2" complete class="flex-column px-0" color="#2CD8C5">
            <v-btn small depressed class="mt-5 ml-2 text-capitalize font-weight-bold titleText--text" style="
                box-shadow: 0px 4px 15px rgba(80, 93, 111, 0.1);
                border-radius: 10px;
              "
              color="white">New variable creation</v-btn>
          </v-stepper-step>
          <div class="border__dashed">
          </div>
          <v-stepper-step step="3" class="d-flex flex-column pl-0">
            <v-btn 
            depressed
            small
            class="mt-5 ml-2 text-capitalize font-weight-bold titleText--text"
            @click="onnextclick(), goTo('variabletransformation')">Transformation</v-btn>
          </v-stepper-step>
      </v-stepper>
    </div>
    <div class="d-flex justify-space-between">
      <v-row>
        <v-col cols="9">
          <v-btn-toggle mandatory borderless color="blue">
            <v-btn height="36" small exact @click="onclickbtn(1)">
              <span class="text-capitalize font-weight-bold titleText--text"
                >Parameter</span
              >
            </v-btn>
            <v-btn height="36" small exact @click="onclickbtn(3)">
              <span class="text-capitalize font-weight-bold titleText--text"
                >Processed data</span
              >
            </v-btn>
          </v-btn-toggle> </v-col
        ><v-col cols="3">
          <div class="mt-5" v-if="this.bttype != 1">
            <v-select
            class="ml-5"
            solo
            flat
            dense
            hide-details
            style="border-radius: 8px; border: 2px solid #f3f5f8"
            v-model="dataregionSelected"
            :items="dataregion"
            @change="callRegionChangeEvent()"
            v-if="this.isregiosubnnational"
          ></v-select
        ></div
        ></v-col>
      </v-row>
    </div>
    <div v-if="bttype === 1">
      <v-card flat class="custom-shadow mt-5">
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <DummyVariable></DummyVariable>
            </v-col>
            <v-col cols="6">
              <v-card flat color="rgb(243, 245, 248, .4)" rounded height="600">
                <v-card-title class="d-flex justify-space-between align-center mb-3">
            <h3 class="titleText--text">Synergy Effect | Linear Combination of Variables</h3>
            <v-btn icon color="blue" title="Create New  Dummy Variables">
              <v-icon
                @click="showAdddilog()"
                >mdi-plus-circle</v-icon
              >
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-simple-table
        fixed-header
        sortable="true"
      >
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left titleText--text font-weight-bold" style="background: rgb(243, 245, 248)">
                {{ "Name" | tableheader }}
              </th>
              <th class="text-left  titleText--text font-weight-bold" style="background: rgb(243, 245, 248)">
                {{ "varType" | tableheader }}
              </th>
              <th class="text-left  titleText--text font-weight-bold" style="background: rgb(243, 245, 248)">Equation</th>
              <th
                class="text-right  titleText--text font-weight-bold"
                style="width: 45px !important; background: rgb(243, 245, 248)"
              ></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in itemVariablename" :key="item.var_name" style="background: rgb(243, 245, 248, .4)">
              <td class="text-left titleText--text font-weight-bold">{{ item.var_name }}</td>
              <td class="text-left darkGrey--text">{{ item.var_type }}</td>
              <td class="text-left darkGrey--text">
                {{ item.equation }}
              </td>
              <td class="text-right">
                <div class="d-flex">
                  <v-btn title="Edit variable" small icon @click="showEditdilog(item.id), getVariableDetails(item.id)">
                    <v-icon color="titleText">mdi-pencil-outline</v-icon>
                  </v-btn>
                  <v-btn title="Delete Variable" small icon @click="showAlertConfirm(item.id)">
                    <v-icon color="red">mdi-trash-can-outline</v-icon>
                  </v-btn>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
              </v-card>
        </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
    <div v-if="bttype === 3">
       <v-row>
        <v-col md="12">
          <CtrlNewVariablegraphview
            ref="refgraphview"
            :title="dataregionSelected"
            :regionlist="listofregion"
          ></CtrlNewVariablegraphview>
        </v-col>
        <v-col cols="12">
          <Ctrlsynegrygridview ref="ctrlsynegrygridview"   :title="dataregionSelected"></Ctrlsynegrygridview>
        </v-col>
      </v-row>
    </div>
    <div>
      <v-dialog v-model="dialog" persistent width="600">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card>
            <v-card-title>
              <h4 class="titleText--text">Synergy Effect Variable</h4>
              <v-spacer />
              <v-btn color="titleText" icon @click="closeForm()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <div class="d-flex justify-space-between">
                <v-text-field
                  v-model="txtvarname"
                  :counter="50"
                  placeholder="Variable"
                  solo
                  flat
                  background-color="#F3F5F8"
                ></v-text-field>
                <v-select
                  v-model="itemvar_type_selected"
                  :items="itemvar_type"
                  item-value="value"
                  item-text="Name"
                  placeholder="Select Equation"
                  return-object
                  solo
                  flat
                  background-color="#F3F5F8"
                  class="ml-3"
                ></v-select>
              </div>
              <div v-if="selectedvarid" class="d-flex justify-end">
                <v-btn text small color="blue" @click="showAddDetails(selectedvarid, txtvarname)">
                 <span class="text-capitalize font-weight-bold">Add Details</span> <v-icon small class="ml-1">mdi-plus-circle</v-icon>
                </v-btn>
              </div>
               <v-col cols="12" v-if="variableDetails.length">
              <v-simple-table dense fixed-header height="auto" sortable="true">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left titleText--text font-weight-bold">
                        Variable
                      </th>
                      <th class="text-left titleText--text font-weight-bold">
                        Type
                      </th>
                      <th class="text-left titleText--text font-weight-bold">
                        Region
                      </th>
                      <th class="text-left titleText--text font-weight-bold">Weight</th>
                      <th
                      ></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in variableDetails" :key="item.name">
                      <td class="text-left titleText--text font-weight-bold">{{ item.variable }}</td>
                      <td class="text-left darkGrey--text">{{ item.newvar__var_type }}</td>
                      <td class="text-left darkGrey--text">{{ item.region }}</td>
                      <td class="text-left darkGrey--text">
                        {{ item.weight }}
                      </td>

                      <td class="text-right">
                        <v-btn small icon @click="removeDetail(item.id)">
                          <v-icon color="red" small>mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                :disabled="!valid"
                color="blue"
                class="ml-2"
                depressed
                dark
                height="36"
                width="120"
                @click="addupdatevariable()"
              >
                <span class="text-capitalize font-weight-bold">Save</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <SeffectvariableDetails ref="ctrlSeffectvariableDetails"
        @refreshvariablegrid="refreshSeffectvariabletable()"
        @onSaveDetails="onSaveDetails(items)"
      ></SeffectvariableDetails>
    </div>
  </v-container>
</template>

<script>
import AuthCtrl from "../../../components/AuthAction.vue";
import globalclass from "../../../global/globalvar";
import apifactory from "../api";
import SeffectvariableDetails from "../views/SeffectvariableDetails.vue";
import DummyVariable from "../views/DummyVariables.vue";
import CtrlNewVariablegraphview from "../views/ctrlNewVariablegraphview.vue";
//import CtrlNavButton from "../../../components/CtrbuttonSaveAndNext.vue";
import Ctrlsynegrygridview from "../views/ctrlSynegyEffectgridView.vue";
import apinew from '../api';
export default {
  components: {
    //AppWidget,
    SeffectvariableDetails,
    Ctrlsynegrygridview,
    DummyVariable,
    AuthCtrl,
    //CtrlNavButton,
    CtrlNewVariablegraphview
  },
  data: () => ({
    stepidCurrent_SVC: 7, // globalclass.PARAM_Step_MDP_SVC,
    stepidPrevious: 6, // globalclass.PARAM_Step_MDP_AS,
    currentprojectid: "0",
    prevstepQueryStringParm: [],
    currentloginuser: "9",
    variableDetails: [],
    prevstepQueryStringParmUrl: [],
    bttype: 1,
    itemVariablename: [],
    valid: true,
    dialog: false,
    txtvarname: "",
    selectedvarid: 0,

    ItemvarData: [],
    itemvar_type: [],
    itemvar_type_selected: [],

    dataregion: [],
    dataregionSelected: [],
    isregiosubnnational: false,
  }),

  methods: {
    goTo(url) {
      this.$router.push(url)
    },
    onSaveDetails () {
      this.getVariableDetails()
    },
    getVariableDetails() {
      console.log('details')
      apifactory
        .call_save_newvar_detail_byid(this.selectedvarid)
        .then((res) => this.variableDetails = res.data)
        .catch((error) => {
          console.warn(error);
        });
    },
    check: function (e) {
      e.cancelBubble = true;
      console.log("checkbox checked");
    },
    expansionPanel: function () {
      console.log("expansion panel");
    },
    onnextclick() {
       this.api_call_save_step4();
      this.savestepparameter_forstep7();
    },
    savestepparameter() {
      let strparms =
        "step=" +
        globalclass.PARAM_Step_MDP_SVC +
        "&" +
        this.prevstepQueryStringParmUrl;
      apifactory
        .addParameterByStepsbyurl(strparms)
        .then((res) => {
          if (res.status != 200) {
            // return false;
            alert("Sorry");
          } 
          /*else {
            alert('done');
           // this.$store.commit("ModelDataPreparation/ADD_ITEM", 3);
            //this.$router.push("/variabletransformation");
          }*/
        })
        .catch(function (error) {
          alert(error);
          // return false;
        });
      // this.saveAndSetStepParms();
    },
    savestepparameter_forstep7() {
      let strparms =
        "step=" +
        globalclass.PARAM_Step_MDP_DVC +
        "&" +
        this.prevstepQueryStringParmUrl;
      apifactory
        .addParameterByStepsbyurl(strparms)
        .then((res) => {
          if (res.status != 200) {
            // return false;
            alert("Sorry");
          } else {
            this.savestepparameter_forstep8();
          }
        })
        .catch(function (error) {
          alert(error);
          // return false;
        });
      // this.saveAndSetStepParms();
    },
    savestepparameter_forstep8() {
      let strparms =
        "step=" +
        globalclass.PARAM_Step_MDP_LCVC +
        "&" +
        this.prevstepQueryStringParmUrl;
      apifactory
        .addParameterByStepsbyurl(strparms)
        .then((res) => {
          if (res.status != 200) {
            // return false;
            alert("Sorry");
          } else {
            this.savestepparameter();
          }
        })
        .catch(function (error) {
          alert(error);
          // return false;
        });
      // this.saveAndSetStepParms();
    },
    onclickbtn(varbttype) {
      //alert(varbttype);
     
      this.bttype = varbttype;
      if(this.bttype ==4){
      this.api_call_save_step4();
       
       
      }
      if(this.bttype ==3){
      this.api_call_save_step4();
       
       
      }
    },
     api_call_save_step4() {
      apifactory
        .call_save_step3()
        .then((res) => {
          // alert(res.data.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } 
          this.api_call_save_step4_next();
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
     api_call_save_step4_next() {
      apifactory
        .call_save_step4()
        .then((res) => {
          // alert(res.data.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } 
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    onPreviewclick() {
      alert("call start");
      this.getvarData();
      alert("call end");
    },
    addupdatevariable() {
      //alert(this.txtvarname);
       if (typeof this.txtvarname == "undefined") {
        alert("Please enter the Name");
        return;
      }
      if (this.txtvarname == "") {
        alert("Please enter the Name");
        return;
      }
       if (typeof this.itemvar_type_selected == 'undefined') {
        alert("Please select variable type");
        return;
      }
       if (this.itemvar_type_selected.value == '') {
        alert("Please select variable type");
        return;
      }
      if (this.selectedvarid != 0) {
        alert(JSON.stringify(this.itemvar_type_selected));
        this.newvairableEditSyegy();
      } else {
        alert(JSON.stringify(this.itemvar_type_selected.value));
        //alert(JSON.stringify(this.itemvar_type_selected[0].value));
        this.addnew_syegy();
      }
    },
    getvarData() {
      apifactory
        .call_getdata_fornewvarceation()
        .then((res) => {
          // alert(res.data.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            this.ItemvarData = res.data;
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
      addnew_syegy() {
      //let apiurl = apifactory.countryAdd(this.countryName, this.currencyCode, "manish"); // "http://mmmplatformapi-env.eba-dtpwwm2u.ap-south-1.elasticbeanstalk.com/country/?name=" + this.countryName + "&currencycode=" + this.currencyCode + "&isactive=" + this.isActive;
      //alert(this.itemRole.id);
      apifactory
        .call_save_newvar_AddNew(
          this.txtvarname,
         this.itemvar_type_selected.value
        )
        .then((res) => {
          // alert(res.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            this.reset();
            this.getallnewvariables();
            this.dialog = false;
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    addnew() {
      //let apiurl = apifactory.countryAdd(this.countryName, this.currencyCode, "manish"); // "http://mmmplatformapi-env.eba-dtpwwm2u.ap-south-1.elasticbeanstalk.com/country/?name=" + this.countryName + "&currencycode=" + this.currencyCode + "&isactive=" + this.isActive;
      //alert(this.itemRole.id);
      apifactory
        .newvariable_Addnew(
          this.currentprojectid,
          this.stepidCurrent_SVC,
          this.txtvarname,
          this.currentloginuser
        )
        .then((res) => {
          // alert(res.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            this.reset();
            this.getallnewvariables();
            this.dialog = false;
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },

    newvairableEditSyegy() {
      //let apiurl = apifactory.countryAdd(this.countryName, this.currencyCode, "manish"); // "http://mmmplatformapi-env.eba-dtpwwm2u.ap-south-1.elasticbeanstalk.com/country/?name=" + this.countryName + "&currencycode=" + this.currencyCode + "&isactive=" + this.isActive;
      //alert(this.itemRole.id);
      apifactory
        .call_save_newvar_edit(
          this.selectedvarid,
          this.txtvarname,
           this.itemvar_type_selected.value
        )
        .then((res) => {
          // alert(res.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            this.reset();
            this.getallnewvariables();
            this.dialog = false;
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },

    getvariablebyid(id) {
      apifactory
        .newvariable_getbyid(id)
        .then((res) => {
          // alert(res.data.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            this.txtvarname = res.data.name;
            
            this.dialog = true;
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    showAdddilog() {
      this.dialog = true;
      this.selectedvarid = 0;
      //commonhelper.showmsg('test');
    },
    showEditdilog(varid) {
      this.getVariableDetails()
      let databyid = []
      databyid= this.itemVariablename.filter(a=>a.id == varid);
      //alert(JSON.stringify(databyid));
      this.selectedvarid = varid;
      this.txtvarname=databyid[0].var_name;
      this.itemvar_type_selected =this.itemvar_type.filter(a=>a.value == databyid[0].var_type)[0];
      //alert(JSON.stringify(this.itemvar_type_selected));
      //this.getvariablebyid(varid);
      this.dialog = true;
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    closeForm() {
      this.reset();
      this.isShowpwd = true;
      this.dialog = false;
    },
    getParametrOfPrvStep() {
      this.prevstepQueryStringParm = "";

      apifactory
        .gettheParameterByProjectStep(this.stepidPrevious)
        .then((res) => {
          if (res.status != 200) {
            this.prevstepQueryStringParm = "";
            // alert(this.processdataitems.length);
          } else {
            this.prevstepQueryStringParm = res.data;

            let strurl = "";
            for (var k in this.prevstepQueryStringParm) {
              if (k != "step") {
                strurl =
                  strurl + k + "=" + this.prevstepQueryStringParm[k] + "&";
                // alert( this.prevstepQueryStringParm[k]);
              }
            }
            strurl = strurl.slice(0, -1);
            this.prevstepQueryStringParmUrl = strurl;
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    gettheprojectid() {
      this.currentprojectid = apifactory.getcurrentproject();
    },

    getallnewvariables() {
      this.itemVariablename = [];
      apifactory
        .call_save_newvar_getbyprojectid()
        .then((res) => {
          if (res.status != 200) {
            this.itemVariablename = [];
            // alert(this.processdataitems.length);
          } else {
            this.itemVariablename = res.data;
          }
          //alert(this.itemVariablename.length);
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    showAlertConfirm(varid) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.newvairableDelete(varid);
          /*this.$swal(
                        'Deleted!',
                        'Your Data has been deleted.',
                        'success'
                    )*/
        }
      });
    },
    removeDetail (id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.deleteDetail(id);
        }
      });
    },
    deleteDetail(id) {
      //.newvariableDetail_Delete(varid, this.currentloginuser, this.varid)
      apifactory
      .call_save_newvar_detail_delete(id, this.selectedvarid, this.currentloginuser)
                .then((res) => {
          // alert(res.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            this.getVariableDetails();
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    newvairableDelete(varid) {
      //let apiurl = apifactory.countryAdd(this.countryName, this.currencyCode, "manish"); // "http://mmmplatformapi-env.eba-dtpwwm2u.ap-south-1.elasticbeanstalk.com/country/?name=" + this.countryName + "&currencycode=" + this.currencyCode + "&isactive=" + this.isActive;
      //alert(this.itemRole.id);
      apifactory
        .call_save_newvar_delete(varid)
        .then((res) => {
          //alert(res.id);

          if (res.status != 200) {
            //this.countryList = null;
            // alert(res.message);
          } else {
            this.reset();
            this.getallnewvariables();
            this.dialog = false;
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },

    // variable details
    showAddDetails(varid, varname) {
      this.$refs.ctrlSeffectvariableDetails.binddefalutvalues(varid,varname)
      //bus.$emit("submit", varid, varname);
    },
    refreshSeffectvariabletable() {
      // alert('call by child');
      this.getallnewvariables();
    },
    getitemvar_type() {
      /*let temitemvar_type = [];
      let obj = new Object();
      obj.Name = "LinearCombination";
      obj.value = "linear_combination";
      temitemvar_type.push(obj);
      let obj1 = new Object();
      obj1.Name = "synergy";
      obj1.value = "synergy";
      temitemvar_type.push(obj1);*/
      let temitemvar_type = [];
      this.itemvar_type = apinew.call_get_itemvar_type();
      this.itemvar_type_selected = temitemvar_type[0];
    },

    callRegionChangeEvent() {
      
      if (this.bttype == 3) {
        this.$refs.refgraphview.refresh(this.dataregionSelected);
         this.$refs.ctrlsynegrygridview.refresh(this.dataregionSelected);
      }
    },
    getprojectregions() {
      this.listofregion = [];
      apifactory.call_get_project_region_list().then((res) => {
        if (res.status != 200) {
          // return false;
        } else {
          if (res.data.length == 0) {
            this.isregiosubnnational = false;
            this.listofregion.push("national");
            this.dataregionSelected = this.listofregion[0];
          } else {
            this.isregiosubnnational = true;
            this.listofregion = res.data.filter((a) => a != "national");
            this.dataregionSelected = this.listofregion[0];
          }
          this.dataregion = this.listofregion;
          //alert('data:-'+this.listofregion.length);
        }
      });
    },
  },
  mounted() {
    this.gettheprojectid();
    this.getParametrOfPrvStep();
     this.getprojectregions();
    this.getallnewvariables();
    this.getitemvar_type();
     this.api_call_save_step4();
  },
};
</script>

<style scoped>
.title_text {
  font-size: 15px !important;
}

.v-label {
  font-size: 10px !important;
}



.exppanel-header {
  height: 50px !important;
  background-color: white !important;
}

.priviewIcon {
  color: purple !important;
}
.customselectbox {
  padding-top: 10px !important;
  width: 80% !important;
}

.border__dashed {
  border: 1px dashed #505D6F; 
  opacity: .4; 
  height: 0px; 
  width: 100px; 
  margin-top: 5%;
}
</style>
